<template>
  <v-container fluid>
    <v-card class="mb-2">
      <v-card-title primary-title>
        <h3 class="headline mb-0">{{ $t('B1500.title') }}</h3>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="search()" class="btn-search" v-permit.SHARP_PO_SEARCH>{{
          $t('app.buttons.search')
        }}</v-btn>
        <v-btn @click="poExportCsv()" v-permit.SHARP_PO_INV_CSV_DOWNLOAD>{{
          $t('app.buttons.poExport')
        }}</v-btn>
        <v-btn @click="ivExportCsv()" v-permit.SHARP_PO_CSV_DOWNLOAD>{{
          $t('app.buttons.ivExport')
        }}</v-btn>
        <!-- <v-btn @click="addDepartment()">补事业部</v-btn> -->
        <v-spacer />
        <!-- <v-btn @dblclick="mock" class="elevation-0" style="background-color: #fff; color: #fff">A</v-btn> -->
      </v-card-actions>
    </v-card>

    <v-card>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex
              md3
              sm6
              v-if="
                $store.getters.user.roles.every(
                  (r) => r.roleCode !== 'ROLE_PARTNER'
                )
              "
              xs12
            >
              <remote-autocomplete
                :label="$t('app.labels.partner')"
                url="companies/kvt?type=PARTNER"
                v-model="query.partnerId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.poNo')"
                clearable
                v-model="query.poNo"
              ></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2 sm6 xs6>
                  <date-picker
                    :label="$t('app.labels.createDate')"
                    v-model="query.createDateFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2 sm6 xs6>
                  <date-picker
                    :min="query.createDateFrom"
                    label="~"
                    v-model="query.createDateTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.bu.name')"
                url="divisions/kv?type=BU"
                v-model="query.buId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.skuCode')"
                v-model="query.skuCode"
              ></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2 sm6 xs6>
                  <date-picker
                    :label="$t('app.labels.productionDate')"
                    v-model="query.productionDateFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 sm6 xs6>
                  <date-picker
                    :min="query.productionDateFrom"
                    label="~"
                    v-model="query.productionDateTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-select
                :items="showStatus"
                :label="$t('B1500.labels.status')"
                clearable
                item-text="text"
                item-value="value"
                v-model="query.status"
              ></v-select>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-checkbox
                :label="$t('B1500.labels.isLeftInvoice')"
                v-model="query.isLeftInvoice"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card>
      <fixed-column-wrap :data="results">
        <template slot-scope="{}">
          <v-data-table
            :headers="headers"
            :items="showResults"
            :loading="loading"
            :pagination.sync="pagination"
            :rows-per-page-items="[10]"
            :total-items="pagination.totalItems"
            item-key="id"
            select-all
            v-model="selected[pagination.page]"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  hide-details
                  primary
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td>{{ props.item.partnerCode }}-{{ props.item.partnerName }}</td>
              <td>{{ props.item.poNo }}</td>
              <td>{{ props.item.source }}</td>
              <td>{{ props.item.siNo }}</td>
              <td>{{ props.item.lotNo }}</td>
              <td>{{ props.item.masterStatus }}</td>
              <td>{{ props.item.companyName }}</td>
              <td>{{ props.item.buCode }}-{{ props.item.buName }}</td>
              <td>
                {{ props.item.departmentCode }}-{{ props.item.departmentName }}
              </td>
              <td>
                {{ props.item.loadingPortCode }}-{{
                  props.item.loadingPortName
                }}
              </td>
              <td>
                {{ props.item.dischargePortCode }}-{{
                  props.item.dischargePortName
                }}
              </td>
              <!-- <td v-if="!productNotExists(props.item)">{{ productShow(props.item) }}</td>
            <td class="warn" v-if="productNotExists(props.item)">
              {{ productShow(props.item) }}
              <v-icon @click="editProduct(props.item)" key="1">edit</v-icon>
          </td>-->
              <td>{{ props.item.productCode }}</td>
              <td>{{ props.item.productName }}</td>
              <td v-if="!productNotExists(props.item)">
                {{
                  props.item.skuCode == null
                    ? props.item.innerSatCode
                    : props.item.skuCode
                }}
              </td>
              <td class="warn" v-if="productNotExists(props.item)">
                {{
                  props.item.skuCode == null
                    ? props.item.innerSatCode
                    : props.item.skuCode
                }}
                <v-icon @click="editSku(props.item)" key="2">edit</v-icon>
              </td>
              <td v-if="!skuSupplierNotExists(props.item)">
                {{
                  props.item.skuSupplierCode == null
                    ? props.item.outerSatCode
                    : props.item.skuSupplierCode
                }}
              </td>
              <td class="warn" v-if="skuSupplierNotExists(props.item)">
                {{
                  props.item.skuSupplierCode == null
                    ? props.item.outerSatCode
                    : props.item.skuSupplierCode
                }}
                <!-- <v-icon @click="editSku" key="3">edit</v-icon> -->
              </td>
              <td>{{ props.item.classificationName }}</td>
              <td>{{ props.item.currencyCode }}</td>
              <td>{{ props.item.qty }}</td>
              <td>{{ props.item.unitPrice }}</td>
              <!-- <td>{{ total(props.item) }}</td> -->
              <td>{{ props.item.subTotal }}</td>
              <td>{{ props.item.create_date }}</td>
              <td>{{ props.item.finishedQty }}</td>
              <td>{{ props.item.createdInvoice }}</td>
              <td>{{ props.item.leftInvoice }}</td>
              <td>{{ props.item.productionDate }}</td>
              <td>{{ props.item.leftSupply }}</td>
              <td>{{ props.item.orderCode + ':' + props.item.orderName }}</td>
              <td>
                {{ props.item.consignorCode + ':' + props.item.consignorName }}
              </td>
              <td>{{ props.item.payment }}</td>
              <td>{{ props.item.creationTime }}</td>
              <td>
                {{
                  props.item.scWarehouseName == null
                    ? props.item.warehouseSatCode +
                      '-' +
                      props.item.warehouseSatName
                    : props.item.scWarehouseCode +
                      '-' +
                      props.item.scWarehouseName
                }}
              </td>
              <td>{{ props.item.classificationName }}</td>
              <td>{{ props.item.deptSubjectCode }}</td>
              <td>{{ props.item.deptConstituteCode }}</td>
              <td>{{ props.item.deptAbstractCode }}</td>
              <td>{{ props.item.deptCode }}</td>
            </template>
          </v-data-table>
        </template>
      </fixed-column-wrap>
    </v-card>
    <csv-fields ref="csvFields" />
    <new-sku-dialog @callback="search" ref="skuNew"></new-sku-dialog>
    <mock-dialog ref="mockDlg"></mock-dialog>
    <add-department-dialog ref="addDepartment"></add-department-dialog>
  </v-container>
</template>

<script>
import MockDialog from './MockDialog'
import newSkuDialog from './skuNewDialog'
import CsvFields from '@/components/CsvFields'
import AddDepartmentDialog from './AddDepartmentDialog'
export default {
  components: {
    CsvFields,
    newSkuDialog,
    MockDialog,
    AddDepartmentDialog,
  },
  data() {
    return {
      load: false,
      status: '',
      showDialog: false,
      selected: {},
      loading: false,
      ivCsvHeaders: [
        'poNo',
        'invoiceNo',
        'siNo',
        'lotNo',
        'srNo',
        'leftInvoice',
        'flag',
        'cartonStartNo',
        'cartonEndNo',
        'nw',
        'gw',
        'm3',
      ],
      ivCsvShowHeaders: [
        'P/O NO',
        'Invoice No',
        'S/I No',
        'Lot No',
        'S/R No',
        'Quantity',
        this.$t('app.labels.package.flag'),
        'CartonStart',
        'CartonEnd',
        'N/W',
        'G/W',
        'M3',
      ],
      headers: [
        {
          text: this.$t('app.labels.partner'),
          value: 'partnerCode',
          sortable: false,
          class: 'fixed',
        },
        {
          text: this.$t('app.labels.poNo'),
          value: 'poNo',
          sortable: false,
          class: 'fixed',
        },
        {
          text: 'source',
          value: 'source',
          sortable: false,
        },
        {
          text: this.$t('app.labels.siNo'),
          value: 'siNo',
          sortable: false,
        },
        {
          text: this.$t('app.labels.lotNo'),
          value: 'lotNo',
          sortable: false,
        },
        {
          text: this.$t('B1500.labels.status'),
          value: 'masterStatus',
          sortable: false,
        },
        {
          text: '企業名称',
          value: 'companyCode',
          sortable: false,
        },
        {
          text: this.$t('app.labels.bu.name'),
          value: 'buCode',
          sortable: false,
        },
        {
          text: this.$t('app.labels.department.name'),
          value: 'departmentCode',
          sortable: false,
        },
        {
          text: this.$t('app.labels.loadingPort'),
          value: 'loadingPortCode',
          sortable: false,
        },
        {
          text: this.$t('app.labels.dischargePort'),
          value: 'dischargePortCode',
          sortable: false,
        },
        {
          text: this.$t('app.labels.productCode'),
          value: 'productCode',
          sortable: false,
        },
        {
          text: '品種名',
          value: 'productName',
          sortable: false,
        },
        {
          text: this.$t('app.labels.skuCode'),
          value: 'skuCode',
          sortable: false,
        },
        {
          text: this.$t('app.labels.skuSupplierCode'),
          value: 'skuSupplierCode',
          sortable: false,
        },
        {
          text: this.$t('app.labels.classification'),
          value: 'classificationName',
          sortable: false,
        },
        {
          text: this.$t('app.labels.currencyCode'),
          value: 'currencyCode',
          sortable: false,
        },
        {
          text: this.$t('B1500.labels.qty'),
          value: 'qty',
          sortable: false,
        },
        {
          text: this.$t('B1500.labels.unitPrice'),
          value: 'unitPrice',
          sortable: false,
        },
        {
          text: this.$t('B1500.labels.subTotal'),
          value: 'subTotal',
          sortable: false,
        },
        {
          text: this.$t('app.labels.createDate'),
          value: 'create_date',
          sortable: false,
        },
        {
          text: this.$t('B1500.labels.finishedQty'),
          value: 'finishedQty',
          sortable: false,
        },
        {
          text: this.$t('B1500.labels.createdInvoice'),
          value: 'createdInvoice',
          sortable: false,
        },
        {
          text: this.$t('B1500.labels.leftInvoice'),
          value: 'leftInvoice',
          sortable: false,
        },
        {
          text: this.$t('app.labels.productionDate'),
          value: 'productionDate',
          sortable: false,
        },
        {
          text: this.$t('B1500.labels.leftSupply'),
          value: 'leftSupply',
          sortable: false,
        },
        {
          text: this.$t('B1500.labels.orderName'),
          value: 'orderName',
          sortable: false,
        },
        {
          text: '購買依頼者',
          value: 'consignorName',
          sortable: false,
        },
        {
          text: 'payment',
          value: 'payment',
          sortable: false,
        },
        {
          text: '作成時間',
          value: 'creationTime',
          sortable: false,
        },
        {
          text: this.$t('app.labels.warehouse'),
          value: 'scWarehouseName',
          sortable: false,
        },
        {
          text: '部品区部',
          value: 'classificationName',
          sortable: false,
        },
        {
          text: '科目コード',
          value: 'deptSubjectCode',
          sortable: false,
        },
        {
          text: '内訳コード',
          value: 'deptConstituteCode',
          sortable: false,
        },
        {
          text: '摘要コード',
          value: 'deptAbstractCode',
          sortable: false,
        },
        {
          text: '部門コード”',
          value: 'deptCode',
          sortable: false,
        },
      ],
      showStatus: [
        {
          text: 'PO取込済',
          value: true,
        },
        {
          text: '未登録マスタデータあり',
          value: false,
        },
      ],
      query: {
        isLeftInvoice: false,
      },
      pagination: {
        rowsPerPage: 10,
      },
      results: [],
      showResults: [],
    }
  },
  methods: {
    loadData() {
      this.load = true
      this.loading = true
      this.$http.get('/purchase-order-inquiry', this.params()).then((res) => {
        this.pagination.page = res.data.number + 1
        this.pagination.rowsPerPage = res.data.size
        this.pagination.totalItems = res.data.totalElements

        this.results = res.data.content
        this.results.forEach((p) => {
          if (
            //this.productNotExists(p) ||
            this.skuNotExists(p) ||
            this.skuSupplierNotExists(p)
            // || this.warehouseNotExists(p)
          ) {
            p.status = 'innormal'
          } else {
            p.status = 'normal'
          }
        })
        this.showResults = this.results
        this.loading = false
      })
    },
    findProductExists(item) {
      return this.$http.get(`/products/product-exists/${item.productSatCode}`)
    },
    findSkuExists(item) {
      return this.$http.get(`/skus/sku-exists/${item.innerSatCode}`)
    },
    findWarehouseExists(item) {
      return this.$http.get(
        `/warehouses/warehouse-exists?code=${item.warehouseSatCode}`
      )
    },
    editSku(item) {
      console.log(item)
      this.$refs.skuNew.popup(item).then(() => {
        this.search()
      })
    },
    editWarehouse(item) {
      this.findWarehouseExists(item).then((res) => {
        if (res.data) {
          this.$http.post('/purchase-orders/po-warehouse', {
            code: item.warehouseSatCode,
            name: item.warehouseSatName,
          })
          this.$router.push({
            path: `/M0091/edit?id=${res.data}`,
          })
        } else {
          this.$router.push({
            path: '/M0091/new',
            query: {
              code: item.warehouseSatCode,
              name: item.warehouseSatName,
            },
          })
        }
      })
    },
    // total(item) {
    //   return item.qty * item.unitPrice
    // },
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
        },
      }
    },
    search() {
      this.pagination.page = 0
      this.$storeParams()
      this.loadData()
      this.selected = {}
    },
    // back() {
    //   this.$router.go(-1)
    // },
    productNotExists(item) {
      return item.itemClassfication == 1 && item.productCode == null
    },
    skuNotExists(item) {
      return item.itemClassfication == 1 && item.skuCode == null
    },
    skuSupplierNotExists(item) {
      return item.itemClassfication == 1 && item.skuSupplierCode == null
    },
    warehouseNotExists(item) {
      return item.scWarehouseId == null
    },
    productShow(item) {
      return item.productCode == null
        ? item.productSatCode + '-' + item.productSatName
        : item.productCode + '-' + item.productName
    },
    afterInqueryOrOnlySelected() {
      var arr = [].concat(...Object.values(this.selected))
      if (arr != null && arr.length > 0) {
        return new Promise((resolve) => resolve()).then(() => arr)
      }
      return this.$http
        .get('/purchase-order-inquiry?needParam=true', {
          params: {
            ...this.query,
            ...this.$pageable(),
            size: 99999,
            page: 0,
          },
        })
        .then((res) => {
          return res.data.content
        })
    },
    poFieldsSortFunc(fields) {
      return (a, b) => {
        for (let i = 0; i < fields.length; i++) {
          let field = fields[i]
          let v1 = a[field.value]
          let v2 = b[field.value]
          if (field.sort === '') return 0
          if (field.sort === 'desc') {
            let temp = v1
            v1 = v2
            v2 = temp
          }
          if (v1 === v2) continue
          if (v1 > v2) return 1
          else return -1
        }
        return 0
      }
    },
    poExportCsv() {
      this.$refs.csvFields
        .popup(this.$t('app.buttons.poExport'), this.downloadHeaders, [0, 1, 2])
        .then((fields) => {
          this.afterInqueryOrOnlySelected().then((list) => {
            list.sort(this.poFieldsSortFunc(fields))
            console.log(list)
            console.log(fields.map((f) => f.value))
            console.log(fields.map((f) => f.text))

            this.$exportTable(
              list,
              fields.map((f) => f.value),
              fields.map((f) => f.text),
              'POデータCSV出力'
            )
          })
        })
    },
    ivExportCsv() {
      // var arr = Object.values(this.selected).flat()
      var arr = [].concat(...Object.values(this.selected))
      if (
        arr.filter((s) => {
          return s.leftInvoice != null && s.leftInvoice == 0
        }).length > 0
      ) {
        this.$message('', this.$t('B1500.messages.errors.checkLeftInvoice'))
      } else if (this.hasDifBu()) {
        this.$message('', this.$t('B1500.messages.errors.hasDifBu'))
      } else {
        this.afterInqueryOrOnlySelected().then((list) => {
          this.$exportTable(
            list,
            this.ivCsvHeaders,
            this.ivCsvShowHeaders,
            'IV作成用CSV出力'
          )
        })
      }
    },
    hasDifBu() {
      var arr = [].concat(...Object.values(this.selected))
      var bu = arr
        .map((i) => i.buId)
        .reduce((t, i) => {
          if (t.indexOf(i) == -1) {
            t.push(i)
          }
          return t
        }, [])
      if (bu.length > 1) {
        return true
      } else {
        return false
      }
    },
    mock() {
      var arr = [].concat(...Object.values(this.selected))
      if (arr[0]) this.$refs.mockDlg.popup(arr[0]).then(() => this.loadData())
    },
    addDepartment() {
      var arr = [].concat(...Object.values(this.selected))
      this.$refs.addDepartment.popup(arr[0])
    },
  },
  mounted() {
    this.$loadParams()
  },
  watch: {
    pagination() {
      if (this.load) this.loadData()
    },
    status() {
      if (this.status == 'normal') {
        this.showResults = this.results.filter((c) => c.status == 'normal')
      } else if (this.status == 'innormal') {
        this.showResults = this.results.filter((c) => c.status == 'innormal')
      } else {
        this.showResults = this.results
      }
    },
  },
  computed: {
    downloadHeaders() {
      return [
        {
          text: this.$t('app.labels.partner') + '名',
          value: 'partnerName',
          sortable: false,
        },
        ...this.headers,
      ]
    },
  },
}
</script>

<style scoped>
.warn {
  color: red;
}
</style>
